import { createSvgComponent } from "../../icon/createSvgComponent";
import GiftFill from "@core/icon/assets/gift-fill.svg";
export default createSvgComponent(GiftFill);